<template>
    <!-- 气泡框组件 -->
    <div class="vel-popover">
        <!-- 确认框 -->
        <el-popconfirm
        v-if="popover"
        :confirm-button-text='confirmText'
        :cancel-button-text='cancelText'
        :icon="icon"
        :icon-color="iconColor"
        :title="title"
        :hide-icon="hideIcon"
        @confirm="show"
        @cancel="hide"
        >
            <span slot="reference">
                <slot name="reference"></slot>
            </span>
        </el-popconfirm>
        <!-- 不带按钮气泡框 -->
        <el-popover
        v-else
        :placement="placement"
        :width="width"
        :trigger="trigger"
        @show="show"
        @hide="hide">
            <span slot="reference">
                <slot name="reference"></slot>
            </span>
            <slot></slot>
        </el-popover>
    </div>
</template>
<script>
export default {
    name:"VelPopover",
    props:{
        confirmText:{
            type:String,
            default:'确定'
        },
        cancelText:{
            type:String,
            default:'取消'
        },
        icon:{
            type:String,
            default:'el-icon-delete'
        },
        iconColor:{
            type:String,
            default:'red'
        },
        title:{
            type:String,
            default:'确定删除此条数据吗？'
        },
        placement:{
            type:String,
            default:'top'
        },
        width:{
            type:[String,Number],
            default:'400'
        },
        trigger:{
            type:String,
            default:'hover'
        },
        isHideIcon:Boolean,
        isPopover:Boolean,
    },
    data() {
        return {
            hideIcon:false,
            popover:false,
        };
    },
    created() {
        this.initDataFn()
    },
    methods: {
        initDataFn(){
            this.isHideIcon ? this.hideIcon = true : this.hideIcon
            this.isPopover ? this.popover = false : this.popover = true
        },
        hide(){
            this.$emit('hide')
        },
        show(){
            this.$emit('show')
        },
    },
}
</script>